export function validateWidgetImage(file: File) {
  const result = {
    isValid: true,
    error: '',
  };

  if (!file || !file.size) {
    result.isValid = false;
    result.error = 'File does not exist';
  }

  const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
  const extension = file.name.split('.').pop()!.toLowerCase();
  if (!allowedExtensions.includes(extension)) {
    result.isValid = false;
    result.error = 'Invalid file type';
  }

  const maxSize = 10 * 1024 * 1024;
  if (file.size > maxSize) {
    result.isValid = false;
    result.error = 'File is too large';
  }

  const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'];
  if (!imageTypes.includes(file.type)) {
    result.isValid = false;
    result.error = 'Invalid file type';
  }

  return result;
}
